<div class="mask"></div>
<div class="popup" *ngFor="let message of toasts;let $key =index">

    <div class="popup-container {{message.type === 'error' ? 'error' : 'success'}}">
        <div class="popup-header">
            <!-- <h4 class="form-title">NPS Investment Period for YTD<button type="button" (click)="closeMessage($key)" class="close _btn-close">×</button></h4> -->
            <h4 class="form-title">NPS<button type="button" (click)="closeMessage($key)" class="close _btn-close">×</button></h4>
        </div>
        <div class="{{message.type === 'error' ? 'failure-card' : 'success-card'}} card-body">
            <div class="{{message.type === 'error' ? 'failure-tick' : 'success-tick'}}">
                <h2>{{message.type === 'error' ? '' : 'success'}}</h2>
            </div>
            <h6 class="text-center" [innerHTML]="message.text"></h6>
            <div class="text-center">
                <a href="javascript:void(0);" (click)="closeMessage($key)" class="btn btn-primary _btn-close">OK</a>
            </div>
        </div>
    </div>
</div>